import '../styles/products.scss';
import { Link } from 'react-router-dom';

export const CategoryCard = (props: any) => {
    return <div className='card-container'> 
      <Link  to={`/productos/${props.categoryId}`} className='card'>
      <div className='card-img'><img src={props.productcImg} alt="" /></div>
      <div className='card-title'>
        <p>{props.productName}</p>
      </div>
    </Link>
  </div>
  }